import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/partners`;
const mappingBaseUrl =
  process.env.REACT_APP_GITO_API_URL + "/partners/PartnerThirdPartySystem";
const thirdPartyBaseUrl =
  process.env.REACT_APP_GITO_API_URL + "/partners/PartnerThirdPartySystemMapping";

// Function to get all partners
export async function getAllPartners(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/partner/get-all-partners`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch partners');
    }
}

export async function getAllPartnersForUser(userPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/partner/get-partners-for-user/${userPublicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch partners');
    }
}

/* export async function getPartner(partnerPublicId, apiAccessToken) {
  console.log('About to call getPartner', { url: `${baseUrl}/partner/get-partner/${partnerPublicId}` });
    try {
        const response = await axios.get(`${baseUrl}/Partner/get-partner/${partnerPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
          });
          console.log('getPartner response:', response.data);
        return response.data;

    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch partners');
    }
} */

    export async function getPartner(partnerPublicId, apiAccessToken) {
  const url = `${baseUrl}/Partner/get-partner/${partnerPublicId}`; // OBS: casing
  console.log('[getPartner] baseUrl =', baseUrl);
  console.log('[getPartner] final URL =', url);
  console.log('[getPartner] token prefix =', apiAccessToken?.slice(0, 10));

  try {
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    console.log('[getPartner] axios DONE status=', response.status);
    return response.data;
  } catch (error) {
    console.error('[getPartner] axios ERROR =', error);
    throw new Error(error.response?.data?.detail || 'Failed to fetch partners');
  }
}

export async function getPartnersForCustomer(customerPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Partner/get-partners-for-customer/${customerPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch partners for customer');
    }
}

export async function getCharingSitePriceByChargingSite(chargingSitePublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/PartnerChargingSitePrice/get-partner-charging-site-prices-by-charging-site/${chargingSitePublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch partners for customer');
    }
}

export async function createPartnerSitePrice(sitePrice, apiAccessToken) {
    try {
        const response = await axios.post(`${baseUrl}/PartnerChargingSitePrice/create-partner-charging-site-price`, sitePrice, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to create site price');
    }
}

export async function deletePartnerSitePrice(sitePricePublicId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrl}/PartnerChargingSitePrice/delete-partner-charging-site-price/${sitePricePublicId}`, {
            headers: {
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to delete site price');
    }
}

export async function postCreatePartner(partnerData, apiAccessToken) {
    /*
    {
        "name": "string",
        "description": "string",
        "partnerValue": 0,
        "minKwh": 0,
        "maxKwh": 0,
        "startDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "endDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "isCalculatedPerPartner": true,
        "partnerConditionType": "string",
        "partnerValueType": "string"
    }
  */

    try {
        const response = await axios.post(`${baseUrl}/Partner/create-partner`, partnerData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to create partner');
    }
}

export async function updatePartner(partnerData, apiAccessToken) {
    /*
    {
        "name": "string",
        "description": "string",
        "partnerValue": 0,
        "minKwh": 0,
        "maxKwh": 0,
        "startDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "endDateTimeUtc": "2024-10-31T08:08:15.390Z",
        "isCalculatedPerPartner": true,
        "partnerConditionType": "string",
        "partnerValueType": "string"
    }
  */

    try {
        const response = await axios.put(`${baseUrl}/Partner/update-partner`, partnerData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to create partner');
    }
}

export async function postAssignPartnerToCustomer(partnerPublicId, customerPublicId, apiAccessToken) {
    try {
        const response = await axios.post(`${baseUrl}/Partner/assign-partner-to-customer/${partnerPublicId}/${customerPublicId}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to assign partner to customers');
    }
}

export async function postRemovePartnerToCustomer(partnerPublicId, customerPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrl}/Partner/remove-partner-from-customer/${partnerPublicId}/${customerPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to assign partner to customers');
    }
}

export async function deletePartner(partnerPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrl}/Partner/delete-partner/${partnerPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to delete partner');
    }
}

export async function addPartnerToSite(partnerPublicId, sitePublicId, apiAccessToken) {
    try {
        await axios.put(`${baseUrl}/partner/add-partner-to-charging-site/${partnerPublicId}/${sitePublicId}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to add site to partner");
    }
}

export async function removePartnerFromSite(partnerPublicId, sitePublicId, apiAccessToken) {
    try {
        await axios.delete(`${baseUrl}/partner/remove-partner-from-charging-site/${partnerPublicId}/${sitePublicId}`, {
            headers: {
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to remove site from partner");
    }
}

export async function getAllThirdPartySystems(apiAccessToken) {
    try {
      const response = await axios.get(
        `${mappingBaseUrl}/get-all-third-party-systems`,
        {
        headers: {
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail || "Failed to fetch third-party systems"
      );
    }
  }
  

  // Function to get third-party system mapping for a charging site
  export async function getPartnerThirdPartySystemMapping(
    partnerPublicId,
    apiAccessToken
  ) {
    try {
      const response = await axios.get(
        `${thirdPartyBaseUrl}/get-partner-third-party-system-mapping-for-partner/${partnerPublicId}`,
        {
          headers: {
            "Authorization": `Bearer ${apiAccessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail ||
          "Failed to fetch third-party system mapping"
      );
    }
  }
  
  // Function to add third-party system mapping for a charging site
  export async function addPartnerThirdPartySystemMapping(
    mappingData,
    apiAccessToken
  ) {
    try {
      const response = await axios.post(
        `${thirdPartyBaseUrl}/add-partner-third-party-system-mapping`,
        mappingData,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${apiAccessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail || "Failed to add third-party system mapping"
      );
    }
  }
  
  // Function to update third-party system mapping for a charging site
  export async function updatePartnerThirdPartySystemMapping(
    mappingData,
    apiAccessToken
  ) {
    try {
      const response = await axios.put(
        `${thirdPartyBaseUrl}/update-partner-third-party-system-mapping`,
        mappingData,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${apiAccessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail ||
          "Failed to update third-party system mapping"
      );
    }
  }
  
  // Function to delete third-party system mapping for a charging site
  export async function deletePartnerThirdPartySystemMapping(
    partnerPublicId,
    thirdPartySystemPublicId,
    thirdPartySystemExternalId,
    apiAccessToken
  ) {
    try {
      const response = await axios.delete(
        `${thirdPartyBaseUrl}/delete-partner-third-party-system-mapping/${partnerPublicId}/${thirdPartySystemPublicId}/${thirdPartySystemExternalId}`,
        {
          headers: {
            "Authorization": `Bearer ${apiAccessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.detail ||
          "Failed to delete third-party system mapping"
      );
    }
  }